<template>
    <div class="item-wrapper">
        <a class="thumb" :href="item.permalink"><img v-img-responsive="{ device: device, images: item.images }"
                :alt="item.title" /></a>
        <div class="content">
            <div class="infos aside-inner">
                <div class="people infos-detail"><span class="icon-people" v-for="(n, index) in item.people"
                        :key="index"></span></div>
                <div class="surface infos-detail m-dp-none">{{ item.surface }} m²<span class="icon-surface"></span></div>
                <div class="options m-dp-none">
                    <span v-for="(service, index) in item.services" :key="index"><img :src="service.icon"
                            :alt="service.name" :title="service.name" /></span>
                </div>
            </div>

            <div class="content-inner">
                <h2 v-if="archives"><a :href="item.permalink" v-text="item.title"></a></h2>
                <h3 class="h2" v-else><a :href="item.permalink" v-text="item.title"></a></h3>
                <p class="description" v-html="item.description"></p>
            </div>

            <a :href="bookingLink" target="_blank" class="btn btn-blue btn-reserver aside-inner">
                <span v-text="$filters.translate('reserver')"></span>
            </a>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import dayjs from 'dayjs';
import vImgResponsive from '@/directives/v-img-responsive';

const store = useStore();

const props = defineProps({
    item: {
        type: Object,
        default: null
    },
    archives: {
        type: Boolean,
        default: true
    },
    hotel: {
        type: [Object, Boolean],
        default: false
    }
});

const device = computed(() => store.state.device);
const configBookingLink = computed(() => store.state.configBookingLink);
const bookingLang = computed(() => store.getters.bookingLang);

const bookingLink = computed(() => {
    if (!props.item) {
        return null;
    }

    let startDate = dayjs();
    let url = props.hotel
        ? window.urlBaseBooking + window.bookingSettings['room_item_path_for_hotel']
        : window.urlBaseBooking + window.bookingSettings['room_item_path'];

    return url +
        '?lingua_int=' + bookingLang.value +
        '&id_stile=' + (props.hotel ? props.hotel.booking_engine.id_stile : configBookingLink.value.id_stile) +
        '&dc=' + (props.hotel ? props.hotel.booking_engine.dc : '') +
        '&id_albergo=' + (props.hotel ? props.hotel.booking_engine.id_albergo : '') +
        '&gg=' + startDate.format('D') +
        '&mm=' + startDate.format('M') +
        '&aa=' + startDate.format('YYYY') +
        '&notti_1=1' +
        '&tot_adulti=1' +
        '&tot_bambini=0' +
        '&tot_camere=1';
});
</script>
